import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { InstitutionsServicesList } from "@/features/institutions/components/institutions-services-list";
import { useInstitutionsContext } from "@/features/institutions/contexts/institutions-context";
import { InstitutionsType } from "@/shared/config/globals"

interface Props {
  onTapCloseModal: () => void;
}

// 金融機関選択モーダル
export const SelectInstitutionsServiceModal = (props: Props) => {
  const {
    onTapCloseModal,
  } = props;

  const {
    institutionType,
  } = useInstitutionsContext();

  const institutionTypeName = (() => {
    let name = "";
    switch (institutionType) {
      case InstitutionsType.Bank:
        name = "銀行口座";
        break;
      case InstitutionsType.Card:
        name = "クレジットカード";
        break;
      case InstitutionsType.ElectronicMoney:
        name = "電子マネー";
        break;
      case InstitutionsType.Other:
        name = "その他サービス";
        break;
    }
    return name;
  })();

  return (
    <BasePageModal
      title={`${institutionTypeName}用Web明細帳を作成`}
      handleClose={() => {
        onTapCloseModal();
      }}
      className={`md-method-bank ${institutionType}`}
      disableOverlayClose={true}
    >
      <h2>
        サービスを選択してください
      </h2>
      <h3>口座を連携して更新を自動化</h3>
      <InstitutionsServicesList />
      {/* <dl className="inner-comment">
        <dt>ご注意事項</dt>
        <dd>注意事項はここに入力</dd>
        <dd>複数件出力可能。箇条書きで表示されます。</dd>
      </dl> */}
    </BasePageModal>
  );
};